import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'


export const _ListingPriceHistoryContainer = styled.div`
  padding: 0 0 24px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 24px 0 22px 0;
  }
`
